"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _server = require("react-dom/server");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _grid = require("../../fuse-responsive-grid/src/grid");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var linkConfig = {
  large: {
    fontSize: "var(--font-size-1)",
    lineHeight: "var(--font-line-height-1)",
    iconMarginSide: "var(--spacing-global-space2)",
    iconSize: '20px',
    underlineOffset: '7px'
  },
  medium: {
    fontSize: "var(--font-size-m1)",
    lineHeight: "var(--font-line-height-m1)",
    iconMarginSide: "var(--spacing-global-space1)",
    iconSize: '18px',
    underlineOffset: '5px'
  },
  small: {
    fontSize: "var(--font-size-m2)",
    lineHeight: "var(--font-line-height-m2)",
    iconMarginSide: "var(--spacing-global-space1)",
    iconSize: '16px',
    underlineOffset: '4px'
  }
};
// Generate CSS link text and padding based on size and icon
var linkSizeCss = function linkSizeCss(size, iconRight, icon) {
  return "\n\tline-height: calc(".concat(linkConfig[size].lineHeight, " + 2px);\n\ttext-underline-offset: ").concat(linkConfig[size].underlineOffset, ";\n\tfont-size: ").concat(linkConfig[size].fontSize, ";\n\n\t").concat(!iconRight && icon ? "padding:0 0 0 calc(".concat(linkConfig[size].lineHeight, " + ").concat(linkConfig[size].iconMarginSide, ");") : "", "\n");
};
// Generate CSS link icon based on size and icon
var iconSizeCss = function iconSizeCss(size, iconRight, icon) {
  var Icon = icon;
  return "\n\t".concat(iconRight ? "\tmargin:0 0 0 ".concat(linkConfig[size].iconMarginSide, ";\n\t\t\t\theight: ").concat(linkConfig[size].lineHeight, ";") : " position: absolute;\n\t\t\t\ttop:0;\n\t\t\t\tleft:0;\n\t\t\t\theight: calc(".concat(linkConfig[size].lineHeight, " + 2px);"), "\n\n\twidth: calc(").concat(linkConfig[size].lineHeight, " - 1px);\n\tmask: url(\"data:image/svg+xml,").concat(encodeURIComponent((0, _server.renderToStaticMarkup)(Icon)), "\") center/").concat(linkConfig[size].lineHeight, " no-repeat;\n\t-webkit-mask: url(\"data:image/svg+xml,").concat(encodeURIComponent((0, _server.renderToStaticMarkup)(Icon)), "\") center/").concat(linkConfig[size].lineHeight, " no-repeat;\n");
};
var StyledLink = _styledComponents["default"].a.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['centreAlign', 'focusable', 'icon', 'iconRight', 'imagePosition', 'isButton', 'size', 'standalone', 'underline', 'white'].includes(prop);
  }
}).attrs({
  className: 'fuse-styled-link'
}).withConfig({
  displayName: "styled-link__StyledLink",
  componentId: "sc-1uszpt7-0"
})(["", ""], function (_ref) {
  var centreAlign = _ref.centreAlign,
    focusable = _ref.focusable,
    icon = _ref.icon,
    iconRight = _ref.iconRight,
    isButton = _ref.isButton,
    size = _ref.size,
    standalone = _ref.standalone,
    underline = _ref.underline,
    white = _ref.white;
  // Array of breakpoints i.e. xxs, xs, s, m, l, xl, xxl
  var breakpointsList = Object.keys(_grid.gridConfig);

  // Array of valid viewports from size prop passed
  var viewports = _typeof(size) === 'object' && Object.keys(size).filter(function (item) {
    return breakpointsList.includes(item);
  });
  // Check if size prop passed is responsive based on viewports above
  var isResponsive = viewports.length > 0;
  // Function to set CSS based on array of viewports
  var setViewportCss = function setViewportCss(cssForViewport) {
    return viewports.reduce(function (acc, viewport) {
      var viewportSize = size[viewport];
      var viewportCss = "\n\t\t\t\t\t@media screen and (min-width: ".concat(_grid.gridConfig[viewport].minWidth, ") {\n\t\t\t\t\t\t").concat(cssForViewport(viewportSize, iconRight, icon), "\n\t\t\t\t\t}\n\t\t\t\t");
      return acc + viewportCss;
    }, '');
  };
  var iconPseudoEl = iconRight ? 'after' : 'before';
  var textDecorationUnderline = function textDecorationUnderline(colour) {
    return "\n\t\t\ttext-decoration-line: underline;\n\t\t\ttext-decoration-color: ".concat(white ? "var(--color-global-white)" : colour, ";\n\t\t\ttext-decoration-style: solid;\n\t\t\ttext-decoration-thickness: 1px;\n\t\t");
  };
  // Set colour when white prop or variant is false
  var setColour = function setColour(colour) {
    return white ? "var(--color-global-white)" : colour;
  };
  return "\n\t\t\tcolor: ".concat(setColour('var(--color-global-grey900)'), ";\n\t\t\tdisplay: ").concat(standalone ? 'block' : 'inline-block', ";\n\t\t\tfont-weight: var(--font-weight-paragraph);\n\t\t\t").concat(standalone ? "\n\t\t\t\t\t\twidth: fit-content;\n\t\t\t\t\t\tmargin: var(--spacing-global-space5) ".concat(centreAlign ? 'auto' : '0', "\n\t\t\t\t\t\t\t\tvar(--spacing-global-space7);\n\t\t\t\t\t\t@media screen and (min-width: ").concat(_grid.gridConfig.m.minWidth, ") {\n\t\t\t\t\t\t\tmargin: var(--spacing-global-space6) ").concat(centreAlign ? 'auto' : '0', "\n\t\t\t\t\t\t\t\tvar(--spacing-global-space9);\n\t\t\t\t\t\t}\n\t\t\t\t\t") : "", "\n\t\t\t").concat(underline ? textDecorationUnderline("var(--color-global-grey500)") : "text-decoration-line: none;", "\n\t\t\t").concat(isButton ? "\n\t\t\t\t\t\tborder: unset;\n\t\t\t\t\t\tbackground: unset;\n\t\t\t\t\t\tcursor: pointer;\n\t\t\t\t\t\tpadding: 0;\n\t\t\t\t\t" : "", "\n\n\t\t\t").concat(isResponsive ? setViewportCss(linkSizeCss) : linkSizeCss(size, iconRight, icon), "\n\n\t\t\t&:hover,\n\t\t\t&:focus {\n\t\t\t\tcolor: ").concat(setColour('var(--color-brand-dark)'), ";\n\t\t\t\t").concat(textDecorationUnderline("var(--color-brand-dark)"), "\n\t\t\t}\n\n\t\t\t&:active {\n\t\t\t\tcolor: ").concat(setColour('var(--color-global-black)'), ";\n\t\t\t\t").concat(textDecorationUnderline("var(--color-global-black)"), "\n\t\t\t}\n\n\t\t\t").concat(focusable ? "\n\t\t\t\t\t&:active,\n\t\t\t\t\t&:focus {\n\t\t\t\t\t\toutline: var(--border-radius-s, 2px) solid var(--color-functional-focus);\n\t\t\t\t\t\toutline-offset: 0;\n\t\t\t\t\t}" : '', "\n\n\t\t\t&[aria-disabled] {\n\t\t\t\tcolor: ").concat(setColour('var(--color-global-grey400)'), ";\n\t\t\t\ttext-decoration-line: none;\n\t\t\t\t").concat(underline ? textDecorationUnderline("var(--color-global-grey400)") : "", "\n\t\t\t\toutline: none;\n\t\t\t}\n\n\t\t\t/* invisible pseudo element to make the tappable area on buttons at least 44x44px */\n\t\t\tposition: relative;\n\n\t\t\t").concat(iconRight ? "&:before" : "&:after", " {\n\t\t\t\tcontent: '';\n\t\t\t\tdisplay: block;\n\t\t\t\tmin-height: 44px;\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 50%;\n\t\t\t\tleft: 50%;\n\t\t\t\ttransform: translate(-50%, -50%);\n\t\t\t\tmin-width: 44px;\n\t\t\t\twidth: 100%;\n\t\t\t}\n\n\t\t\t").concat(icon ? "\n\t\t\t\t\t&:hover:".concat(iconPseudoEl, ",\n\t\t\t\t\t&:focus:").concat(iconPseudoEl, " {\n\t\t\t\t\t\tbackground: ").concat(setColour('var(--color-brand-dark)'), ";\n\t\t\t\t\t}\n\n\t\t\t\t\t&:active:").concat(iconPseudoEl, " {\n\t\t\t\t\t\tbackground: ").concat(setColour('var(--color-global-black)'), ";\n\t\t\t\t\t}\n\n\t\t\t\t\t&[aria-disabled]:").concat(iconPseudoEl, " {\n\t\t\t\t\t\tbackground: ").concat(setColour('var(--color-global-grey400)'), ";\n\t\t\t\t\t}\n\n\t\t\t\t\t&:").concat(iconPseudoEl, " {\n\t\t\t\t\t\tcontent: '';\n\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\tbackground: ").concat(setColour('var(--color-brand-mid)'), ";\n\t\t\t\t\t\tvertical-align: text-bottom;\n\n\t\t\t\t\t\t").concat(isResponsive ? setViewportCss(iconSizeCss) : iconSizeCss(size, iconRight, icon), "\n\t\t\t\t\t}\n\t\t\t\t") : "", "\n\t\t");
});
var _default = exports["default"] = StyledLink;